import { getDocumentUploadData } from '@seek/ca-myprofile-utils';

import type {
  GetDocumentUploadDataQuery,
  GetDocumentUploadDataQueryVariables,
} from 'src/__generated__/graphql';
import { apolloClient } from 'src/modules/graphql-client';

export const generateUploadMetaData = ({
  attachmentId,
}: {
  attachmentId: string;
}) =>
  apolloClient
    .query<GetDocumentUploadDataQuery, GetDocumentUploadDataQueryVariables>({
      query: getDocumentUploadData,
      fetchPolicy: 'no-cache',
      variables: {
        id: attachmentId,
      },
    })
    .then((res) => {
      const metadata = res?.data?.viewer?.documentUploadFormData;
      const formFields = metadata?.formFields;
      const url = metadata?.link;

      if (!formFields || !url) {
        throw new Error('Unable to generate upload metadata');
      }

      return {
        url,
        formFields,
      };
    });
